import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';

@Injectable()
export class ReducersService {
    /**
     *
     */
    // constructor(private _store: Store<IEnvironmentState>) {
    // }

    // getEnvironment() {
    //     return _store.select("environment");
    // }

}